import React from "react";
import "./style.css";
import QueNavigatorBox from "../commonComponents/QueNavigatorBox";

const QuestionNavigator = ({ data }) => {
  return (
    <div className="mcqNav">
      <div className="mcqRightNav">
        <h2>Mcq Questions Navigator</h2>
        <div className="mcqNavTop">
          <div>
            <div className="orangeBox"></div> Answered {}
          </div>
          <div>
            <div className="blackBox"></div> Unanswered {}
          </div>
        </div>
      </div>
      <div className="mcqBoxContainer">
        {data.map((d, index) => (
          <QueNavigatorBox queNo={index + 1} />
        ))}
      </div>
    </div>
  );
};

export default QuestionNavigator;
